module.exports = __webpack_public_path__ + "a6a52520d83222dbd279e7215da30d6a.pdf";